import RowCountSelector from '../RowCountSelector';
import Paginator from '../Paginator';

import styles from './RejectedFooter.module.scss';

const RejectedFooter = () => (
  <footer className={styles.rejectedFooter}>
    <div className={styles.content}>
      <RowCountSelector />
      <Paginator />
    </div>
  </footer>
);

export default RejectedFooter;
